import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { ContentCampaignDetails } from '@pages/offer-details/ui/ContentCampaignDetails';

function OfferDetailsRoute() {
  const { id } = Route.useParams();
  return <ContentCampaignDetails idCampaign={id} />;
}

export const Route = createFileRoute('/_auth/_layout/offers_/$id')({
  component: OfferDetailsRoute,
});
